import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { ResponseState } from "../../../../../../../../react-core/Flux/ResponseState";
import { ChargesRedirectionDispatcher } from "./Variable";

export interface ChargesRedirectionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ChargesRedirectionStatic extends BaseStore<ChargesRedirectionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ChargesRedirectionDispatcher, (actionData) =>
            this.onChargesRedirectionStoreResponse(actionData)
        );
    }

    public getLastResult(): ChargesRedirectionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getChargesRedirectionData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ChargesRedirectionStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onChargesRedirectionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.FlushStore:
                this.setState({ actionType: actionData.actionType, data: ResponseState.Empty });
                break;
        }
    }
}
